export default __webpack_public_path__ + "static/media/ws-vd-icon.ae6c196f.svg";